import script from "./TablaInscritosLiga.vue?vue&type=script&setup=true&lang=ts"
export * from "./TablaInscritosLiga.vue?vue&type=script&setup=true&lang=ts"

import "./TablaInscritosLiga.vue?vue&type=style&index=0&id=ce8acc2e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ce8acc2e"]])

export default __exports__